import { render } from "./Collections.vue?vue&type=template&id=1e2d797e"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"
script.render = render

export default script